import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { baseUrl } from '../shared';
import { StatusChip, ItemIdentity } from '../components/ui';
import Login from '../components/login'
import FirstTab from "../components/tab-components/FirstTab";
import UpdateBookingStatus from "./edit/updateBookingStatus"
import './App.css';
import Search from "../components/search";
import CreateBooking from "./create/createBooking";
import Edit from './edit/editItem';
import EditBooking from "./edit/editBooking";
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Card,
  CardContent,
  Divider,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton,
  Paper,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';



const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const day = date.getDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  const hours24 = date.getHours();
  const hours12 = hours24 % 12 || 12;
  const ampm = hours24 >= 12 ? "PM" : "AM";

  const pad = (n) => String(n).padStart(2, "0");

  return `${day}${suffix} ${monthNames[date.getMonth()]} ${date.getFullYear()} ${hours12}:${pad(date.getMinutes())}:${pad(date.getSeconds())} ${ampm}`;
};

// Detail field for the 2-column detail grid (AIMS pattern): label + value.
const DetailField = ({ label, value, mono, children }) => (
  <Box>
    <Box sx={{ fontSize: 10, color: 'var(--faint)', textTransform: 'uppercase', letterSpacing: '.5px', fontWeight: 600 }}>{label}</Box>
    <Box className={mono ? 'app-mono' : undefined} sx={{ fontSize: 13.5, color: 'var(--text)', mt: '2px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {children ?? (value === null || value === undefined || value === '' ? '—' : value)}
    </Box>
  </Box>
);

function ItemView() {
  // Reactive URL params (via useLocation) so client-side nav - e.g. clicking
  // Home/logo to "/" - clears the current item back to the search screen.
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search.toLowerCase());
  const itemNoUrl = urlParams.get('item');
  const bookingUrl = urlParams.get('booking');

  const [item, setItem] = useState();
  const [bookingView, setBookingView] = useState(false);
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [openSections, setOpenSections] = useState(() => new Set()); // sections expanded below the summary card (independent)
  var [attachments, setAttachments] = useState();
  const [uploadIdForDelete, setUploadIdForDelete] = useState('');
  const [attachmentsOpen, setAttachmentsOpen] = useState(false);
  const [bookingAttachmentsOpen, setBookingAttachmentsOpen] = useState(false);
  var [bookingList, setBookingList] = useState();
  const [bookingListOpen, setBookingListOpen] = useState(false);
  var [pastBookingList, setPastBookingList] = useState();
  const [pastBookingListOpen, setPastBookingListOpen] = useState(false);
  const [newBookingOpen, setNewBookingOpen] = useState(false);
  const [editBookingOpen, setEditBookingOpen] = useState(false);
  const [editItemOpen, setEditItemOpen] = useState(false);
  const [attachmentOpen, setAttachmentOpen] = useState(false);
  const [photos, setPhotos] = useState({});
  const [signatures, setSignatures] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  const lookUpItemNo = async () => {
      const url = baseUrl + 'item/' + itemNoUrl;
      await fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
      .then((response) => response.json())
      .then((data) => {
         setItem(data[0]);
         setBookingView(false);
      })
      .catch((err) => {
         console.log(err.message);
      });
  };

  const lookUpBooking = async () => {
    const url = baseUrl + 'hire/' + bookingUrl;
    await fetch(url, {
      method: 'GET',
      headers: {
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      }})
    .then((response) => response.json())
    .then((data) => {
      console.log("data: ", data)
       setItem(data[0]);
       setBookingView(true);
       console.log("Item: ", item)
    })
    .catch((err) => {
       console.log(err.message);
    });
};

useEffect(() => {
    if (item?.id) {
      fetchPhotos();
      fetchSignatures();
    }
  }, [item?.id]);

  const fetchPhotos = async () => {
    try {
      const res = await fetch(`${baseUrl}booking/photos/${item?.id}`, {
        headers: {
          username: localStorage.getItem("username"),
          bToken: localStorage.getItem("bToken"),
        },
      });
      const json = await res.json();
      if (json.status === 200) setPhotos(json.data || {});
    } catch (err) {
      console.error("Photo fetch error:", err);
    }
  };

  const fetchSignatures = async () => {
    try {
      const res = await fetch(`${baseUrl}booking/signatures/${item?.id}`, {
        headers: {
          username: localStorage.getItem("username"),
          bToken: localStorage.getItem("bToken"),
        },
      });
      const json = await res.json();
      if (json.status === 200) setSignatures(json.data || {});
    } catch (err) {
      console.error("Signature fetch error:", err);
    }
  };

  // React to the URL: load the item / booking, or clear back to search when
  // there is neither (e.g. after clicking Home). Keyed on location.search so it
  // re-runs on client-side navigation, not just the initial page load.
  useEffect(() => {
    if (itemNoUrl) {
      lookUpItemNo();
    } else if (bookingUrl) {
      lookUpBooking();
    } else {
      setItem(undefined);
      setBookingView(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  function showAttachments() {
      const url = baseUrl + 'itemAttachmentList/' + item.itemNo;
      fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
        .then((res) => {
          return res.json();
      }).then((json) => {
           setAttachments(json);
           setAttachmentsOpen(true);
      })
      .catch((err) => {
         console.log(err.message);
      });
    }

    function showBookings() {
        const url = baseUrl + 'hire/list/' + item.itemNo;
        fetch(url, {
          method: 'GET',
          headers: {
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken')
          }})
          .then((res) => {
            return res.json();
        }).then((json) => {
             setBookingList(json);
             setBookingListOpen(true);
        })
        .catch((err) => {
           console.log(err.message);
        });
      }

      function showPastBookings() {
          const url = baseUrl + 'hire/past/list/' + item.itemNo;
          fetch(url, {
            method: 'GET',
            headers: {
                'username': localStorage.getItem('username'),
                'bToken': localStorage.getItem('bToken')
            }})
            .then((res) => {
              return res.json();
          }).then((json) => {
               setPastBookingList(json);
               setPastBookingListOpen(true);
          })
          .catch((err) => {
             console.log(err.message);
          });
        }

    const [open, setOpen] = React.useState(false);
    const [bookingOpen, setBookingOpen] = React.useState(false);
    const [statusOpen, setStatusOpen] = React.useState(false);

    const handleClickOpen = uploadId => {
      setUploadIdForDelete(uploadId)
      setOpen(true);
    };

  const handleClose = () => {
    setUploadIdForDelete('')
    setOpen(false);
  };
  
  const handleStatusClose = () => {
    if(statusOpen === true) {
    setStatusOpen(false)
    } else {
    setStatusOpen(true)
    }
  };
  
  const handleNewBookingView = () => {
    if(newBookingOpen === true) {
    setNewBookingOpen(false)
    } else {
    setNewBookingOpen(true)
    }
  };
  
  const handleEditBookingView = () => {
    if(editBookingOpen === true) {
    setEditBookingOpen(false)
    } else {
    setEditBookingOpen(true)
    }
  };
  
  const handleEditItemView = () => {
    if(editItemOpen === true) {
    setEditItemOpen(false)
    } else {
    setEditItemOpen(true)
    }
  };
  
  const handleAttachmentOpen = () => {
    if(attachmentOpen === true) {
    setAttachmentOpen(false)
    } else {
    setAttachmentOpen(true)
    }
  };

    function delAttachment() {
      const url = baseUrl + 'uploadDel/itemAttachment';
      fetch(url, {
        method: 'POST',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken'),
            'uploadId': uploadIdForDelete
        }}) 
        .then((res) => {
          return res.json();
      }).then((json) => {
           setOpen(false)
           setAttachmentsOpen(false)
           setUploadIdForDelete('')
      })
      .catch((err) => {
         console.log(err.message);
      });
    }

function successCalled() {
      setNewBookingOpen(false);
      setEditBookingOpen(false);
      setEditItemOpen(false);
      setAttachmentOpen(false);
      setStatusOpen(false);
      window.location.reload();
    }

  return (
    
    <div className="itemView">
      <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="confirmDeleteTitle">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmDeleteDesc">
            Are you sure you want to delete the Attachment?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={delAttachment}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    
      <React.Fragment>
      <Dialog
        open={newBookingOpen}
        onClose={handleNewBookingView}
        fullWidth maxWidth="sm"
      >
        <DialogTitle>New Booking</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ pt: 1 }}>
            < CreateBooking bookingItem={item} onSuccess={() => successCalled()}/>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNewBookingView}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    
      <React.Fragment>
      <Dialog
        open={editBookingOpen}
        onClose={handleEditBookingView}
        fullWidth maxWidth="sm"
      >
        <DialogTitle>Edit Booking</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ pt: 1 }}>
            < EditBooking bookingItem={item} onSuccess={() => successCalled()}/>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditBookingView}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    
      <React.Fragment>
      <Dialog
        open={attachmentOpen}
        onClose={handleAttachmentOpen}
        fullWidth maxWidth="sm"
      >
        <DialogTitle>Add Attachment</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ pt: 1 }}>
            < FirstTab foundItem={item} onSuccess={() => successCalled()}/>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAttachmentOpen}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    
      <React.Fragment>
      <Dialog
        open={editItemOpen}
        onClose={handleEditItemView}
        fullWidth maxWidth="sm"
      >
        <DialogTitle>Edit Item</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ pt: 1 }}>
            < Edit foundItem={item} onSuccess={() => successCalled()}/>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditItemView}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

          <React.Fragment>
      <Dialog
        open={statusOpen}
        onClose={handleStatusClose}
        fullWidth maxWidth="sm"
      >
        <DialogTitle>Update Booking Status</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ pt: 1 }}>
            <UpdateBookingStatus bookingItem={item} onSuccess={() => successCalled()}/>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleStatusClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    {localStorage.getItem('username') !== null ? (
  null
): <div>
< Login />
</div>}

<br></br>

{!item && localStorage.getItem('adminFunctions') === '1' ? (
  <div>
    < Search />
  </div>
): null}


    { item ? (
      <Box sx={{ maxWidth: { xs: 640, md: 1100 }, mx: 'auto' }}>
        {/* Go to Inspection Site banner */}
        {localStorage.getItem('adminFunctions') === '1' && !bookingView && item.linkedCatNo ? (
          <Box sx={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow-sm)', p: 1.5, mb: 1.5, textAlign: 'center' }}>
            <a href={'https://asset.1maintenance.com.au/?catNo='+item.linkedCatNo} style={{ color: 'var(--primary)', fontWeight: 700, fontSize: 14, textDecoration: 'none' }}>View Asset in AIMS &rarr;</a>
          </Box>
        ) : null}

        {/* Summary card: meatball (left) + status (right), identity, details */}
        <Box sx={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow-sm)', p: 2.5, mb: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, minHeight: 34 }}>
            {localStorage.getItem('adminFunctions') === '1' ? (() => {
              const actions = bookingView
                ? [
                    { label: 'Update Booking Status', icon: <PublishedWithChangesIcon fontSize="small" />, onClick: () => setStatusOpen(true) },
                    { label: 'Edit Booking', icon: <EditCalendarIcon fontSize="small" />, onClick: () => setEditBookingOpen(true) },
                    { label: 'Back to Item', icon: <ArrowBackIcon fontSize="small" />, onClick: () => { window.location.href = '/?item=' + item.itemNo; } },
                  ]
                : [
                    { label: 'Create Booking', icon: <AddCircleOutlineIcon fontSize="small" />, onClick: () => setNewBookingOpen(true) },
                    { label: 'Edit Item', icon: <EditIcon fontSize="small" />, onClick: () => setEditItemOpen(true) },
                    { label: 'Add Attachment', icon: <AttachFileIcon fontSize="small" />, onClick: () => setAttachmentOpen(true) },
                  ];
              return (
                <>
                  <IconButton aria-label="Item actions" sx={{ ml: -0.5, p: 0.25 }} onClick={(e) => setActionMenuAnchor(e.currentTarget)}>
                    <MoreHorizIcon />
                  </IconButton>
                  <Menu anchorEl={actionMenuAnchor} open={Boolean(actionMenuAnchor)} onClose={() => setActionMenuAnchor(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                    {actions.map((a, i) => (
                      <MenuItem key={i} onClick={() => { setActionMenuAnchor(null); a.onClick(); }}>
                        <ListItemIcon sx={{ minWidth: 34 }}>{a.icon}</ListItemIcon>
                        {a.label}
                      </MenuItem>
                    ))}
                  </Menu>
                </>
              );
            })() : <span />}
            {bookingView && item.status ? (
              <Box onClick={setStatusOpen} sx={{ cursor: 'pointer' }} title="Update booking status">
                <StatusChip domain="booking" value={item.status} dot size="md" />
              </Box>
            ) : null}
          </Box>

          {/* Identity */}
          <Box sx={{ minWidth: 0, mt: -0.5 }}>
            <ItemIdentity item={item} roomy size="block" idStyle={{ fontSize: 21 }} />
            <Box sx={{ fontSize: 12, color: 'var(--muted)', mt: 0.5 }}>
              {bookingView
                ? [`Booking #${item.id}`, item.company].filter(Boolean).join(' · ')
                : [item.name, item.siteLocation].filter(Boolean).join(' · ') || '—'}
            </Box>
          </Box>

          {/* Asset status */}
          { item.assetStatus && !bookingView ? (
            <Box sx={{ border: '1px solid var(--primary)', borderRadius: 'var(--r-sm)', p: 1.5, mt: 2, backgroundColor: 'var(--surface-tint)' }}>
              <Typography variant="subtitle2" sx={{ color: 'var(--primary)' }} fontWeight={600}>Asset Status</Typography>
              <Typography variant="body2" sx={{ mb: 1, color: 'var(--text)' }}>{item.assetStatus || "N/A"}</Typography>
              <Divider sx={{ my: 1 }} />
              <Typography variant="subtitle2" sx={{ color: 'var(--primary)' }} fontWeight={600}>Asset Status Notes</Typography>
              <Typography variant="body2" sx={{ maxHeight: 120, overflowY: "auto", whiteSpace: "pre-wrap", color: 'var(--text)' }}>{item.assetStatusNotes || "No notes available"}</Typography>
            </Box>
          ):null}

          {/* Booking details (booking view) */}
          { bookingView ? (
            <Box sx={{ mt: 2 }}>
              <Box sx={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px', color: 'var(--faint)', mb: 1.5 }}>Booking Details</Box>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '12px 24px' }}>
                <DetailField label="Booking No" value={item.id} mono />
                <DetailField label="Company" value={item.company} />
                <DetailField label="Delivery Date" value={item.startDate} />
                <DetailField label="Return Date" value={item.returnDate} />
                <DetailField label="PO Number" value={item.poNumber} />
                <DetailField label="Invoice Number" value={item.invoiceNumber} />
              </Box>
            </Box>
          ):null}

          {/* Item details */}
          <Box sx={{ mt: 2 }}>
            <Box sx={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px', color: 'var(--faint)', mb: 1.5 }}>Item Details</Box>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '12px 24px' }}>
              <DetailField label="Item Number" value={item.itemNo} mono />
              <DetailField label="Name" value={item.name} />
              <DetailField label="Catalogue Number" value={item.catNo} mono />
              <DetailField label="Asset Number" value={item.assetId} mono />
              <DetailField label="Build Date" value={item.buildDate} />
              <DetailField label="Type" value={item.type} />
              <DetailField label="Site Location" value={item.siteLocation} />
              <DetailField label="Item" value={item.item} />
              <DetailField label="Manufacturer" value={item.manufacturer} />
              <DetailField label="Model" value={item.model} />
              <DetailField label="Serial Number" value={item.serialNo} mono />
              <DetailField label="Max Height" value={item.maxHeight} />
              <DetailField label="Capacity" value={item.capacity} />
              <DetailField label="Next Inspection Due" value={item.nextInspectionDate} />
              <DetailField label="Last Inspected Date" value={item.lastInspectionDate} />
              <DetailField label="Inspection Status" value={item.inspectionStatus} />
            </Box>
          </Box>
        </Box>

        {(() => {
  const admin = localStorage.getItem('adminFunctions') === '1';
  // Section segments (AIMS pattern): a row of buttons; each expands its own
  // content directly below it (same column width), so more than one can be open
  // at once and compared side by side.
  const segments = bookingView
    ? [{ key: 'attachments', label: 'Attachments' }, ...(admin ? [{ key: 'bookingAttachments', label: 'Booking Attachments' }] : [])]
    : [{ key: 'attachments', label: 'Attachments' }, ...(admin ? [{ key: 'upcoming', label: 'Upcoming Bookings' }, { key: 'past', label: 'Past Bookings' }] : [])];
  const toggle = (key) => {
    setOpenSections((prev) => {
      const next = new Set(prev);
      if (next.has(key)) { next.delete(key); return next; }
      next.add(key);
      if (key === 'attachments') showAttachments();
      else if (key === 'upcoming') showBookings();
      else if (key === 'past') showPastBookings();
      return next;
    });
  };
  const body = (key) => {
    if (key === 'attachments') return (
      <Box sx={{ p: 1.5 }}>
        {(attachments || []).map((list, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, py: 0.5, borderBottom: index < (attachments.length - 1) ? '1px solid var(--border)' : 'none' }}>
            <Box component="a" href={list.attachmentUrl} sx={{ color: 'var(--primary)', fontSize: 13, textDecoration: 'none', wordBreak: 'break-word' }}>{list.attachmentName}</Box>
            { admin ? (<IconButton size="small" onClick={() => {handleClickOpen(list.uploadId)}}><Tooltip title="Delete Attachment"><CancelIcon fontSize="small" /></Tooltip></IconButton>): null}
          </Box>
        ))}
        {(!attachments || attachments.length === 0) && <Box sx={{ color: 'var(--muted)', fontSize: 13, py: 1 }}>No attachments.</Box>}
      </Box>
    );
    if (key === 'bookingAttachments') return (
      <Box sx={{ p: 1.5 }}>
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>Booking Photos</Typography>
            <Divider sx={{ mb: 1.5 }} />
            {Object.keys(photos).length === 0 && (<Typography variant="body2" color="text.secondary">No photos found.</Typography>)}
            {Object.entries(photos).map(([status, items]) => (
              <Box key={status} sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mt: 1, mb: 1, fontWeight: 600 }}>Status: {status}</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                  {items.map((photo, i) => (
                    <Box key={photo.id} sx={{ textAlign: 'center' }}>
                      <img src={photo.base64Image} alt={`Booking Photo ${i + 1}`} style={{ width: "90px", height: "90px", objectFit: "cover", borderRadius: "6px", cursor: "pointer" }} onClick={() => setSelectedImage(photo.base64Image)} />
                      <Box sx={{ fontSize: 10, color: 'var(--muted)', mt: 0.25 }}>{formatDateTime(photo.uploadedAt)}</Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>Booking Signatures</Typography>
            <Divider sx={{ mb: 1.5 }} />
            {Object.keys(signatures).length === 0 && (<Typography variant="body2" color="text.secondary">No signatures found.</Typography>)}
            {Object.entries(signatures).map(([status, items]) => (
              <Box key={status} sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mt: 1, mb: 1, fontWeight: 600 }}>Status: {status}</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                  {items.map((sig, i) => (
                    <Box key={sig.id} sx={{ textAlign: 'center' }}>
                      <img src={sig.base64Signature} alt={`Signature ${i + 1}`} style={{ width: "90px", height: "90px", objectFit: "contain", background: "#fff", borderRadius: "6px", cursor: "pointer", border: "1px solid #ddd" }} onClick={() => setSelectedImage(sig.base64Signature)} />
                      <Box sx={{ fontSize: 10, color: 'var(--muted)', mt: 0.25 }}>{formatDateTime(sig.signedAt)}</Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    );
    if (key === 'upcoming' || key === 'past') {
      const list = key === 'upcoming' ? bookingList : pastBookingList;
      const emptyMsg = key === 'upcoming' ? 'No upcoming bookings.' : 'No past bookings.';
      return (
        <Box sx={{ p: 1.5 }}>
          {(list || []).map((b, index) => (
            <Box key={index} onClick={() => {window.location.href='?booking='+b.hyperlink}} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.75, cursor: 'pointer', flexWrap: 'wrap', borderBottom: index < (list.length - 1) ? '1px solid var(--border)' : 'none' }}>
              <StatusChip domain="booking" value={b.status} dot />
              <Box sx={{ fontSize: 13, color: 'var(--text)' }}>{b.fullName} - {b.startDate} to {b.returnDate}</Box>
            </Box>
          ))}
          {(!list || list.length === 0) && <Box sx={{ color: 'var(--muted)', fontSize: 13, py: 1 }}>{emptyMsg}</Box>}
        </Box>
      );
    }
    return null;
  };
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: `repeat(${segments.length}, 1fr)` }, gap: 1, alignItems: 'start', mb: 1.5 }}>
      {segments.map((s) => {
        const open = openSections.has(s.key);
        return (
          <Box key={s.key} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box onClick={() => toggle(s.key)} sx={{
              textAlign: 'center', px: 2, py: 1.25, cursor: 'pointer', fontSize: 13, fontWeight: 700,
              borderRadius: 'var(--r)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-sm)',
              background: open ? 'var(--primary)' : 'var(--surface)',
              color: open ? 'var(--on-primary)' : 'var(--text)',
              '&:hover': { borderColor: 'var(--primary)' },
            }}>{s.label}</Box>
            {open && (
              <Box sx={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow-sm)', overflow: 'hidden' }}>
                {body(s.key)}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
})()}
      </Box>
    ): null}
<br />
<br />
{/* 🖼️ FULL IMAGE PREVIEW */}
      <Dialog open={!!selectedImage} onClose={() => setSelectedImage(null)} maxWidth="md">
        <DialogContent>
          <img
            src={selectedImage}
            alt="Full Size Preview"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "6px",
            }}
          />
        </DialogContent>
      </Dialog>
  </div>
);
}
export default ItemView;